module.exports = __webpack_public_path__ + "static/media/sponsors-natl_endowment_arts.d24d6d92.png";